import { inject, Injectable } from '@angular/core';
import { PortfolioService } from '@easy-lib/modules/portfolio';
import { MarketDataService, SymbolService, TimeService } from '@easy-lib/modules/shared/services';
import { SoldItemsAction } from '@easy-lib/state/sold-items/sold-items.action';
import { Store } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { IPortfolioItem } from '@easy-lib/modules/portfolio/models/portfolio-item.model';
import { SoldItemsFacade } from '@easy-lib/state/sold-items/sold-items.facade';

@Injectable({ providedIn: 'root' })
export class SoldItemsFacadeService {
	private readonly portfolioService: PortfolioService = inject(PortfolioService);
	private readonly SoldItemsFacade: SoldItemsFacade = inject(SoldItemsFacade);
	private readonly store: Store = inject(Store);
	symbolService: SymbolService = inject(SymbolService);
	marketDataService: MarketDataService = inject(MarketDataService);
	timeService: TimeService = inject(TimeService);

	loadSoldItems(minimalApi = true) {
		this.store.dispatch(SoldItemsAction.load({ minimalApi }));
	}
	getSoldMinimalItems(): Observable<IPortfolioItem[]> {
		return this.portfolioService.getPortfolioSoldMinimalItems();
	}
	getSoldItemDetail(isin: string[]) {
		return this.portfolioService.getPortfolioSoldItemsDetail(isin).pipe(
			tap(soldItems => {
				soldItems.forEach(item => {
					delete item.symbolName;
					this.SoldItemsFacade.updateSoldItemsStore([{ ...item }]);
				});
			})
		);
	}
}
